mutation DisconnectConnection($provider: String!) {
  result: StreamToolsDisconnectConnection(provider: $provider) {
    provider
    disconnected
  }
}
